<template>
  <div class="overflow-hidden">
    <div class="plansHolder row">
      <div class="planHolder col-lg-4 col-md-6 col-12"
           v-for="(paket,index) in pakets" :key="paket.id"
           @click="commit_paket(paket,index)"
           :class="currentPaketChoosed(paket)"
           :id="paket.id"

      >
        <div class="planBody">
          <div class="popularPaket" v-if="paket.standard_choice"><i class="icon-gotit"></i>Populär val</div>
          <div class=" contentHolder">
            <div class="floorplanTitle">
              <span v-html="paket.title"></span>
              <span class="paketprice ">{{ paket.price }} kr</span>
            </div>
            <div class="floortplan_description">{{ paket.description }}</div>
            <div class="floortplan_description_points">
              <div class="points">
                <ul >
                  <li v-for="(point,index) in paket.points" :key="'points_'+index"> {{point.point}}</li>
                </ul>
              </div>
            </div>
            <div class="button_holder_paket">
              <button class="checkout_btn_primary rounded-btn mgt-40"><span v-if="currentChoice(paket)">Har valts</span><span v-else>Välj</span></button>
              <div>Ny byggnation av garage</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "floorplans_paket",
  computed: {
    activeLeftNav() {
      return this.$store.state.activeLeftNav
    },
    pakets() {
      return this.$store.state.pakets
    },
    currentPaket() {
      return this.$store.state.currentPaket
    },
  },
  methods: {
    currentChoice(paket){
      if(Object.keys(this.$store.state.currentPaket).length > 0){
       return this.$store.state.currentPaket.id === paket.id ?? true
      }else{
        return  false
      }
    },
    currentPaketChoosed(paket){
      if(Object.keys(this.$store.state.currentPaket).length > 0){
       return this.$store.state.currentPaket.id === paket.id ? 'active' : ''
      }else{
        return  paket.standard_choice ? 'active' : ''
      }
    },
    dispatch_Nav(e) {
      this.$store.dispatch('commit_activeLeftNav', e)

    },
    choosePaket() {
      if (Object.keys(this.currentPaket).length > 0) {
        this.dispatch_Nav('payment')
      }
    },
    commit_paket(e,index) {
      this.$store.dispatch('commit_paket',{paket: e,index:index})
      this.$store.commit('mutate_activeLeftNav','payment')
      this.$store.dispatch('create_order')
    }
  }
}
</script>

<style scoped lang="scss">
.popularPaket{
  padding: 4.99751px 9.99501px;
  gap: 10px;
  display: flex;
  background: #FFF0EE;
  font-weight: 400;
  font-size: 14.9925px;
  line-height: 130%;
  text-align: center;
  color: #CA3214;
  align-items: center;
  justify-content: center;
}
.button_holder_paket{
  display: flex;
  gap: 18px;
  flex-direction: column;
  & > div{
    font-size: 14.9925px;
    line-height: 130%;
    text-align: center;
    color: #8F8F8F;
  }
}

.plansHolder {
  .floortplan_description_points {
    font-weight: 400;
    font-size: 14px;
    line-height: 167%;
    height: 100%;
    ul {
      padding: 20px 20px;
      li{
        line-height: 167%;
      }
    }
  }
  padding: 20px 30px 30px;
  .planHolder {
    margin-bottom: 20px;
    &:hover{
      .planBody{
        box-shadow: -1.24938px 0px 0px 1.24938px rgba(0, 0, 0, 0.05), 0px 2.49875px 7.49626px rgba(0, 0, 0, 0.11), 0px 6.24688px 14.9925px rgba(0, 0, 0, 0.05), 0px 0px 0px 1.24938px rgba(0, 0, 0, 0.05);
      }
     }
    &.active{
        button{
        background-color: #4E9280!important;
        border: #4E9280;
      }
      .planBody{
        box-shadow: -1.24938px 0px 0px 1.24938px rgba(0, 0, 0, 0.05), 0px 2.49875px 7.49626px rgba(0, 0, 0, 0.11), 0px 6.24688px 14.9925px rgba(0, 0, 0, 0.05), 0px 0px 0px 1.24938px rgba(0, 0, 0, 0.05);
      }
    }
    .planBody{
      box-shadow: 0px 1.24938px 2.49875px rgba(0, 0, 0, 0.06), 0px 0px 0px 1.24938px rgba(104, 113, 130, 0.16), 0px 1.24938px 1.24938px rgba(82, 86, 95, 0.08);
      border-radius: 9.99501px;
      cursor: pointer;
      height: 100%;
      .paketprice{
        font-size: 18px;
      }
      .contentHolder{
        padding: 15px 12px;
        display: flex;
        flex-direction: column;
        height: calc(100% - 20px);
      }
      .floorplanTitle {
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      .floortplan_description {
        font-weight: 400;
        font-size: 14px;
        line-height: 167%;
        color: #6F6F6F;
      }
    }

  }
}

</style>
